/* eslint-disable compat/compat */
/**
 * @fileOverview Card to Modal
 * @author Selectra Front End Team
 * @version 3.2.4
 * @requires 'core-js/fn/array/from'
 */

export default function cardToModal() {
  const
    reviews = document
      .querySelectorAll( '.card--customer-review[data-card-to-modal="true"]' );

  if ( reviews.length > 0 ) {
    window.location.hash = '';

    reviews.forEach( review => {
      const
        trigger = review.querySelector( '.card__testimonial-link' ),
        insertionPoint = document.getElementById( 'review__insertion-point' ),
        card = review.cloneNode( true ),
        content = Array.from( card.children );



      trigger.addEventListener( 'click', () => {
        while ( insertionPoint.firstChild ) {
          insertionPoint.removeChild( insertionPoint.firstChild );
        }

        content.forEach( child => {
          insertionPoint.appendChild( child );
        })

      })
    })
  }
}
